import { useSupplier } from "./api/v2/supplier/useSupplier";
import { useRemoteFeatureFlags } from "./useRemoteFeatureFlags";
import { useSellarCurrentBusiness } from "./useSellarCurrentBusiness.shared";

export const useVolumeDiscountMode = () => {
  const { business } = useSellarCurrentBusiness();
  const remoteFeatureFlags = useRemoteFeatureFlags();
  const basicModeFlagEnabled = remoteFeatureFlags.isActive(
    "basicVolumeDiscountMode",
  );
  const unbundlingEnabled = remoteFeatureFlags.isActive(
    "unbundlingReleaseFinal",
  );
  const supplierId = business?.Supplier?.id;
  const supplierQuery = useSupplier(supplierId, {
    enabled: basicModeFlagEnabled && unbundlingEnabled && !!supplierId,
  });
  const modeAvailable = basicModeFlagEnabled && unbundlingEnabled;

  return {
    isBasicMode:
      modeAvailable &&
      supplierQuery.data?.advancedVolumeDiscountsEnabled === false,
    isAdvancedMode:
      !modeAvailable ||
      supplierQuery.data?.advancedVolumeDiscountsEnabled === true,
    isLoading: modeAvailable && supplierQuery.isLoading,
    modeAvailable,
    supplierQuery,
  };
};
